module.exports = __webpack_public_path__ + "static/media/wallpaper-pc.a8c41de5.png";